export default __webpack_public_path__ + "static/media/bg_admin_assessments.cf4e8dae.png";